import { cn } from '@ds';
import { OcsDeviceIcon, ScsIcon } from '@icons';

const iconClassNames = 'w-[48px] h-auto';

export const DeviceImage = ({ isScs, ocsColor }: { isScs: boolean; ocsColor: string }) => {
  return isScs ? (
    <ScsIcon className={cn('text-warning-60', iconClassNames)} />
  ) : (
    <OcsDeviceIcon className={cn(ocsColor, iconClassNames)} />
  );
};
